import type { BookingThemeDataInput, BookingThemeData } from 'owa-graph-schema';

const mapToBookingThemeDataInput = (themeData: BookingThemeData): BookingThemeDataInput => {
    const { paletteId, patternId, pictureId } = themeData;
    const modifiedThemeData: BookingThemeDataInput = {
        paletteId,
        patternId,
        pictureId,
    };
    return modifiedThemeData;
};

export default mapToBookingThemeDataInput;
